<template>
    <div class="modal  fade show  custom-modal" id="advancedSearchInd" :class="{'modal-show':showModal}">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header mr-3">
            <h3 class="modal-title ml-4 pl-2">Advanced Search <span class="individual" v-if="advancedSearchRequest.customerType.value=='I'">(Individual)</span>
            <span class="individual" v-if="advancedSearchRequest.customerType.value=='O'">(Organization)</span>
            </h3>
            <button type="button" class="close" data-dismiss="modal" id="advance-search-cross-close" @click="resetData()">&times;</button>
          </div>
          <!-- Modal body -->
          <div class="modal-body  ">
            <div class="row px-3 mt-3">
              <!-- Customer Type starts -->
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="row form-group">
                  <float-label label="Party Type*" :fixed="isFloat(advancedSearchRequest.customerType.value)">
                    <select
                      v-evolvews="advancedSearchRequest.customerType"
                      v-model="advancedSearchRequest.customerType.value"
                      :class="{ 'bgc-error-field': advancedSearchRequest.customerType.errorText!=='' }"
                      class="form-control bg-error" placeholder="Party Type*">
                      <option disabled selected value="" v-if="advancedSearchRequest.customerType.value==''">Customer Type*</option>
                      <option disabled selected :value='null' v-if="advancedSearchRequest.customerType.value==null">Customer Type*</option>
                      <option value="I">Individual</option>
                      <option value="O">Organization</option>
                    </select>
                  </float-label>
                  <span
                    class="error-text"
                    v-if="advancedSearchRequest.customerType.errorText!==''"
                  >{{advancedSearchRequest.customerType.errorText}}</span>
                </div>
              </div>
              <!-- Customer Type ends -->
            </div>
            <hr>
            <!-- individual search starts -->
            <div class="row px-3 mt-3" v-if="advancedSearchRequest.customerType.value == 'I'">
            <!-- first name starts -->
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="row form-group">
                  <float-label label="First Name" :fixed="isFloat(advancedSearchRequest.individual.firstName.value)">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="First Name"
                      name="firstName"
                      v-evolvews="advancedSearchRequest.individual.firstName"
                      v-model="advancedSearchRequest.individual.firstName.value"
                    />
                  </float-label>
                </div>
              </div>
            <!-- first name ends -->
            <!-- last name starts -->
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="row form-group">
                  <float-label label="Last Name" :fixed="isFloat(advancedSearchRequest.individual.lastName.value)">
                    <input type="text" class="form-control" placeholder="Last Name" name="lastName"
                      v-evolvews="advancedSearchRequest.individual.lastName"
                      v-model="advancedSearchRequest.individual.lastName.value" />
                  </float-label>
                </div>
              </div>
            <!-- last name starts -->
            </div>
            <div class="row px-3 mt-3" v-if="advancedSearchRequest.customerType.value == 'I'">
              <!-- mobile number starts -->
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="row form-group">
                  <float-label label="Mobile Number" :fixed="isFloat(advancedSearchRequest.individual.mobileNumber.value)">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Mobile Number"
                      name="mobileNumber"
                      v-evolvews="advancedSearchRequest.individual.mobileNumber"
                      v-model="advancedSearchRequest.individual.mobileNumber.value"
                    />
                  </float-label>
                </div>
              </div>
              <!-- mobile number ends -->
              <!-- email id starts -->
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="row form-group">
                  <float-label label="Email ID" :fixed="isFloat(advancedSearchRequest.individual.email.value)">
                    <input type="text" class="form-control" placeholder="Email ID" name="emailID" 
                      v-evolvews="advancedSearchRequest.individual.email"
                      v-model="advancedSearchRequest.individual.email.value"/>
                  </float-label>
                </div>
              </div>
              <!-- email id ends -->
              <!-- Pan number starts -->
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="row form-group">
                  <float-label label="PAN Number" :fixed="isFloat(advancedSearchRequest.individual.panNumber.value)">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="PAN Number"
                      v-evolvews="advancedSearchRequest.individual.panNumber"
                      v-model="advancedSearchRequest.individual.panNumber.value"
                      name="panNumber"
                    />
                  </float-label>
                </div>
              </div>
              <!-- pan number ends -->
            </div>
            <!-- individual search ends -->
            <!-- organization search starts  -->
            <div class="row px-3 mt-3" v-if="advancedSearchRequest.customerType.value == 'O'">
              <!-- Organization Name starts -->
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="row form-group">
                <float-label label="Organization Name" :fixed="isFloat(advancedSearchRequest.organisation.organisationName.value)">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Organization Name"
                    name="OrganizationName"
                    v-evolvews="advancedSearchRequest.organisation.organisationName"
                    v-model="advancedSearchRequest.organisation.organisationName.value"
                  />
                </float-label>
                </div>
              </div>
              <!-- Organization Name end -->
              <!-- Business Registration Number starts -->
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="row form-group">
                <float-label label="Business Registration Number" :fixed="isFloat(advancedSearchRequest.organisation.businessRegistrationNumber.value)">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Business Registration Number"
                    name="BusinessRegistrationNumber"
                    v-evolvews="advancedSearchRequest.organisation.businessRegistrationNumber"
                    v-model="advancedSearchRequest.organisation.businessRegistrationNumber.value"
                  />
                </float-label>
                </div>
              </div>
              <!-- Business Registration Number ends -->
            </div>
            <div v-if="state.interimAdvanceSearchError != ''" class="text-danger text-center">{{state.interimAdvanceSearchError}}</div>
          </div>
            <div class="row mt-2 mb-5">
                <div class="col-12 float-right">
                    <button
                    type="button"
                    class="bgc-btn-primary mr-4 float-right "
                    @click="searchParty('advanceSearch')"
                    id="advanceSearch"
                    >Search</button>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>


<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import { reactive } from '@vue/composition-api';
import functions from "@/../../masters/functions.js";

export default {
  name: "AdvancedSearchPartyModal",
  props: ['advancedSearchRequest', 'showModal'],
  components: {
    FloatLabel
  },
  setup(props, context){
    let state = reactive({
      interimAdvanceSearchError : "",
    });
    //methods
    const isFloat= functions.isFloat;
    const checkError= functions.checkError;
    function searchParty(advanceSearch){
      if(Object.keys(props.advancedSearchRequest.individual).some(attr => {return props.advancedSearchRequest.individual[attr].value}) ||
      Object.keys(props.advancedSearchRequest.organisation).some(attr => {return props.advancedSearchRequest.organisation[attr].value})){
          context.parent.searchParty(advanceSearch)
      }
      else{
        state.interimAdvanceSearchError = 'Please enter some search criteria!';
          setTimeout(function(){
              state.interimAdvanceSearchError = '';
          }, 3000);
      }
    }
    function resetData(){
      context.parent.resetData()
    }
    //RETURN
    return{
      state,
      isFloat,
      checkError,
      searchParty,
      resetData
    }
  },
  directives: {
    evolvews: functions.evolvews,
  },
};
</script>

<style scoped>
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.modal-body {
  overflow-y: hidden;
}
.custom-modal {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  transform: scale(0);
}

@keyframes unfoldIn {
  0% {
    transform: scaleY(0.005) scaleX(0);
  }
  50% {
    transform: scaleY(0.005) scaleX(1);
  }
  100% {
    transform: scaleY(1) scaleX(1);
  }
}

.modal-title {
  margin-bottom: 0;
  margin-top: 25px;
  border-bottom: none;
  }

label {
  display: block;
  height: 15px;
}
.modal {
  width: 100%;
}
.individual{
    color: #666666;
}
.ipad-portrait{
  top: 70px;
}
@media (min-width: 576px) { 
  .modal-dialog {
    max-width: 1000px;
    margin: 1.75rem auto;
  }
 } 

select.form-control {
  line-height: 33px;
  max-width: 100%;
}
.mobile-label {
  display: none;
}
@media all and (device-width: 768px) and (device-height: 1024px)  {
  .ipad-portrait { 
    width: 50%;   
  } /* your css rules for ipad portrait */
}
</style>
